import React from 'react';
import { MessageStrip, FlexBox } from '@ui5/webcomponents-react';
import DeviceCard from './DeviceCard';

function DeviceControlPage({ locationProfileDevices, onBack, locationUUID, guestCode }) {
  const hasAppOnlyControl = locationProfileDevices.some(
    d => d.permission === 'CONTROL' && parseInt(d.appOnly) === 1
  );
  const isNative = !!(window.Capacitor && typeof window.Capacitor.isNativePlatform === 'function' && window.Capacitor.isNativePlatform());

  return (
    <div className="shell-container">

      {hasAppOnlyControl && !isNative && (
        <MessageStrip design="Information" hideCloseButton>
          Some devices require the HomeAlerts app for full control
        </MessageStrip>
      )}

      {locationProfileDevices.length === 0 ? (
        <FlexBox justifyContent="Center" style={{ padding: '2rem' }}>
          <p style={{ color: 'var(--sapContent_LabelColor)' }}>No devices available.</p>
        </FlexBox>
      ) : (
        <div className="card-grid">
          {locationProfileDevices.map((device, idx) => (
            <DeviceCard key={idx} device={device} locationUUID={locationUUID} guestCode={guestCode} />
          ))}
        </div>
      )}

      {!isNative && (
        <footer className="store-badges-footer">
          <p className="store-badges-tagline">Get the full experience</p>
          <FlexBox justifyContent="Center" alignItems="Center" gap="0.75rem" wrap="Wrap">
            <a
              href="https://itunes.apple.com/us/app/home-alerts/id1032158222"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download on the App Store"
            >
              <img
                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                alt="Download on the App Store"
                className="store-badge"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.homealertsapp.nest"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get it on Google Play"
            >
              <img
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                alt="Get it on Google Play"
                className="store-badge store-badge-google"
              />
            </a>
          </FlexBox>
        </footer>
      )}

    </div>
  );
}

export default DeviceControlPage;
